import {
    FaUsers,
    FaRocket,
    FaGlobe,
    FaChartLine,
    FaEye,
    FaBullseye,
    FaHtml5,
    FaCss3Alt,
    FaReact,
    FaLaravel,
    FaWordpress,
    FaAndroid,
    FaApple,
    FaPhp,
} from "react-icons/fa";
import {
    SiMysql,
    SiMongodb,
    SiFlutter,
    SiAngular,
    SiJavascript,
} from "react-icons/si";
import "./../styles/About.css";
import photo from "../assets/images/photo.jpeg";
import { useNavigate } from "react-router-dom";

const About = () => {
    const navigate = useNavigate();
    const technologies = [
        { icon: <FaHtml5 />, label: "HTML5", color: "orange" },
        { icon: <FaCss3Alt />, label: "CSS3", color: "blue" },
        { icon: <SiJavascript />, label: "JavaScript", color: "#F0DB4F" },
        { icon: <FaReact />, label: "React", color: "cyan" },
        { icon: <SiAngular />, label: "Angular", color: "red" },
        { icon: <FaPhp />, label: "PHP", color: "indigo" },
        { icon: <FaLaravel />, label: "Laravel", color: "red" },
        { icon: <FaWordpress />, label: "WordPress", color: "blue" },
        { icon: <SiMysql />, label: "MySQL", color: "navy" },
        { icon: <SiMongodb />, label: "MongoDB", color: "darkgreen" },
        { icon: <SiFlutter />, label: "Flutter", color: "dodgerblue" },
        { icon: <FaAndroid />, label: "Android", color: "green" },
        { icon: <FaApple />, label: "iOS", color: "black" },
    ];
    return (
        <div className="about-us">
            <section className="our-story">
                <div className="container">
                    <div className="section-header">
                        <h2>Who We Are</h2>
                        {/* <h3>Where Ideas Meet Innovation</h3> */}
                    </div>
                    <div className="story-content">
                        <div className="story-text">
                            <p>
                                <b>
                                    Welcome to Webcrux Technology Where Ideas
                                    Meet Innovation
                                </b>
                            </p>
                            <p>
                                At Webcrux Technology, we transform digital
                                ideas into reality. With a team of seasoned
                                professionals, we specialize in creating fast,
                                secure, and scalable websites and mobile
                                applications tailored to your unique business
                                needs. Whether you're a startup or an
                                established enterprise, we deliver custom
                                solutions in web development, mobile apps, web
                                applications, UI/UX design, and ongoing support.
                            </p>
                            <p>
                                We’re more than just an IT firm we’re a
                                technology partner you can trust. Our approach
                                is rooted in transparency, quality, and on-time
                                delivery, ensuring that your vision is brought
                                to life with precision and care.
                            </p>
                            <p>
                                With deep industry expertise and a passion for
                                technology, we help businesses of all sizes turn
                                their concepts into powerful IT solutions.
                            </p>
                            <p>
                                Our mission is to drive innovation and empower
                                you to make a meaningful impact in the digital
                                world. At Webcrux, your satisfaction is our
                                priority, and excellence is our standard.
                            </p>
                        </div>
                        <div className="story-image">
                            <img
                                src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                                alt="Our team working"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="our-values">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Core Values</h2>
                    </div>
                    <div className="values-grid">
                        <div className="value-card">
                            <div className="value-icon">
                                <FaUsers />
                            </div>
                            <h3>Client-Centric</h3>
                            <p>
                                We put our clients at the heart of everything we
                                do, building solutions that address their unique
                                challenges.
                            </p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">
                                <FaRocket />
                            </div>
                            <h3>Innovation</h3>
                            <p>
                                We constantly push boundaries to deliver
                                cutting-edge solutions that give our clients a
                                competitive edge.
                            </p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">
                                <FaGlobe />
                            </div>
                            <h3>Global Perspective</h3>
                            <p>
                                With a diverse team and international clientele,
                                we bring world-class solutions to every project.
                            </p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">
                                <FaChartLine />
                            </div>
                            <h3>Results-Driven</h3>
                            <p>
                                We measure our success by the tangible business
                                outcomes we deliver for our clients.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="tech-section">
                <h2 className="tech-title">Our Technology</h2>
                <div className="tech-grid">
                    {technologies.map((tech, index) => (
                        <div key={index} className="tech-card">
                            <div
                                className="tech-icon"
                                style={{ color: tech.color }}
                            >
                                {tech.icon}
                            </div>
                            <span className="tech-label">{tech.label}</span>
                        </div>
                    ))}
                </div>
            </section>

            <section className="vision-mission-container">
                <div className="statement-box vision">
                    <div className="icon-box">
                        <FaEye className="statement-icon" />
                    </div>
                    <div>
                        <h2 className="statement-title">Vision Statement</h2>
                        <ul className="statement-list">
                            <li>
                                We aim to empower you through innovation and
                                cutting-edge technology.
                            </li>
                            <li>
                                We believe every business has the potential to
                                grow and expand its operations.
                            </li>
                            <li>
                                We support businesses of all sizes from startups
                                to multinational corporations in turning their
                                concepts into fully functional IT solutions.
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="statement-box mission">
                    <div className="icon-box">
                        <FaBullseye className="statement-icon" />
                    </div>
                    <div>
                        <h2 className="statement-title">Mission Statement</h2>
                        <ul className="statement-list">
                            <li>
                                Our mission is to deliver superior IT solutions
                                globally with complete client satisfaction and
                                on-time delivery.
                            </li>
                            <li>
                                Renowned for our quick turnaround, Tagline
                                Infotech ensures high-quality results under
                                tight deadlines.
                            </li>
                            <li>
                                Our skilled and dedicated developers prioritize
                                excellence and client success above all.
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="our-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-item">
                            <h3>10+</h3>
                            <p>Projects Completed</p>
                        </div>
                        <div className="stat-item">
                            <h3>10+</h3>
                            <p>Team Members</p>
                        </div>
                        <div className="stat-item">
                            <h3>5+</h3>
                            <p>Countries Served</p>
                        </div>
                        <div className="stat-item">
                            <h3>98%</h3>
                            <p>Client Satisfaction</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="our-team">
                <div className="container">
                    <div className="section-header">
                        <h2>Meet Our Leadership</h2>
                        <p className="team-subtitle">
                            The brilliant minds driving Webcrux Technology
                            forward
                        </p>
                    </div>
                    <div className="team-grid">
                        <div className="team-member">
                            <div className="member-image">
                                <img src={photo} alt="Jinal Soni" />
                            </div>
                            <h3>Jinal Soni</h3>
                            <p className="position">CEO & Founder</p>
                            <p className="bio">
                                Hi, I’m Jinal Soni Founder of Webcrux
                                Technology.
                            </p>
                            <p className="bio" style={{ textAlign: "center" }}>
                                I started this company with a simple goal to
                                deliver quality work with honesty and care. I'm
                                passionate about solving real problems through
                                tech and believe strong communication and trust
                                are just as important as clean code. Behind
                                every project, there's a personal touch because
                                for me, it's not just business.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta-section">
                <h2 className="cta-title">Ready to Start Your Project?</h2>
                <p className="cta-subtitle">
                    Contact us today to discuss how we can help your business
                    grow with our innovative digital solutions.
                </p>
                <div
                    className="cta-container"
                    style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <button
                        onClick={() => navigate("/contact")}
                        className="cta-btns  no-underline"
                        style={{ fontFamily: "Lexend" }}
                    >
                        Contact Us
                    </button>
                    <button
                        onClick={() => navigate("/quote")}
                        className="cta-btn  no-underline"
                        style={{ fontFamily: "Lexend" }}
                    >
                        Get A Quote
                    </button>
                </div>
            </section>
        </div>
    );
};

export default About;
